// src/services/SubscriptionsRequestService.ts

export interface SupportRequest {
  id?: string;
  name: string;
  email: string;
  phone: string;
  subject: string;
  note: string;
  conditions: boolean;
}

/**
 * Add a new SupportRequest to Cosmos DB
 */
export async function addSupportRequest(SupportRequest: SupportRequest): Promise<SupportRequest> {
  const response = await fetch(`/api/sendMessage`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(SupportRequest),
  });

  if (!response.ok) {
    throw new Error(`Error adding SupportRequest: ${response.statusText}`);
  }

  return response.json();
}

/**
 * Get all SupportRequests from Cosmos DB
 */
export async function getSupportRequests(): Promise<SupportRequest[]> {
  const response = await fetch(`/api/getMessages`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`Error fetching SupportRequests: ${response.statusText}`);
  }

  const result = await response.json();
  return result.data;
}

/**
 * Delete SupportRequest by id from Cosmos DB
 */
// export async function deleteSupportRequest(SupportRequest: SupportRequest): Promise<SupportRequest> {
//   const response = await fetch(`${API_BASE_URL}/SupportRequests/${SupportRequest.id}`, {
//     method: "DELETE",
//     headers: {
//       "Content-Type": "application/json",
//     },
//     body: JSON.stringify(SupportRequest),
//   });

//   if (!response.ok) {
//     const errorText = await response.text();
//     throw new Error(`Error deleting SupportRequest: ${response.statusText} - ${errorText}`);
//   }

//   const result: SupportRequest = await response.json();
//   return result;
// }
